





import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { IField } from '@/dealroom/fields/types/field';

@Component
export default class CheckboxField extends Vue {
  @Prop() field: IField;
  @Prop() disabled: boolean;
  @Prop() pressSpace: boolean;

  @Watch('pressSpace')
  handlePressSpace(press) {
    if (press) {
      this.toggle();
    }
  }

  get checked(): boolean {
    return !!parseInt(this.field.value);
  }

  get showRequired(): boolean {
    if (this.disabled) {
      return false;
    }
    return this.field.isRequired;
  }

  toggle(): void {
    if (!this.disabled) {
      this.$emit('update', this.checked ? '' : '1');
    }
  }
}
